export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero */}
      <section className="py-16 md:py-20" style={{ background: 'linear-gradient(135deg, #f8fffe 0%, #ffffff 100%)' }}>
        <div className="container-main">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-6" style={{ color: '#2D3748' }}>
              Privacy Policy
            </h1>
            <p className="text-lg text-gray-600">
              Last updated: February 28, 2026
            </p>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-16">
        <div className="container-main">
          <div className="max-w-3xl mx-auto bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-10">
            <div className="prose prose-gray max-w-none">
              <h2 className="text-2xl font-bold mb-4" style={{ color: '#2D3748' }}>Introduction</h2>
              <p className="text-gray-600 mb-6">
                Financify Caribbean ("we," "our," or "us") is committed to protecting your privacy. 
                This Privacy Policy explains how we collect, use, disclose, and safeguard your 
                information when you use our website and services.
              </p>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Information We Collect</h2>
              <p className="text-gray-600 mb-4">We collect information that you voluntarily provide, including:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                <li>Personal identification information (name, email, phone number)</li>
                <li>Employment information (employer, job title, years employed)</li>
                <li>Financial information (income, existing debts, loan preferences)</li>
                <li>Identity documents (if voluntarily uploaded)</li>
                <li>Account credentials (if you create an account)</li>
              </ul>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>How We Use Your Information</h2>
              <p className="text-gray-600 mb-4">We use the information we collect to:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                <li>Evaluate your potential loan eligibility against bank criteria</li>
                <li>Provide estimated loan amounts, rates, and payments</li>
                <li>Create and manage your account</li>
                <li>Send you your pre-qualification results</li>
                <li>Communicate with you about our services</li>
                <li>Improve our platform and services</li>
              </ul>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Information Sharing</h2>
              <p className="text-gray-600 mb-6">
                We do NOT sell your personal information. We may share your information only:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                <li>With your explicit consent when you choose to connect with a bank</li>
                <li>With service providers who help us operate our platform</li>
                <li>To comply with legal obligations or protect our rights</li>
              </ul>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Data Security</h2>
              <p className="text-gray-600 mb-6">
                We implement appropriate security measures to protect your information:
              </p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                <li>256-bit SSL encryption for data transmission</li>
                <li>Secure cloud infrastructure</li>
                <li>Access controls and authentication</li>
                <li>Regular security assessments</li>
              </ul>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Your Rights</h2>
              <p className="text-gray-600 mb-4">You have the right to:</p>
              <ul className="list-disc pl-6 text-gray-600 space-y-2 mb-6">
                <li>Access the personal information we hold about you</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your information</li>
                <li>Opt out of marketing communications</li>
              </ul>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Cookies</h2>
              <p className="text-gray-600 mb-6">
                We use cookies and similar technologies to improve your experience, analyze usage, 
                and assist in our marketing efforts. You can control cookies through your browser settings.
              </p>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Third-Party Links</h2>
              <p className="text-gray-600 mb-6">
                Our website may contain links to third-party websites. We are not responsible for 
                the privacy practices of these external sites.
              </p>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Changes to This Policy</h2>
              <p className="text-gray-600 mb-6">
                We may update this Privacy Policy from time to time. We will notify you of any 
                material changes by posting the new policy on this page with an updated date.
              </p>

              <h2 className="text-2xl font-bold mb-4 mt-8" style={{ color: '#2D3748' }}>Contact Us</h2>
              <p className="text-gray-600 mb-4">
                If you have questions about this Privacy Policy or our privacy practices, 
                please contact us at:
              </p>
              <div className="bg-gray-50 rounded-xl p-6">
                <p className="text-gray-600">
                  <strong>Email:</strong> support@financify-caribbean.com<br />
                  <strong>Address:</strong> Nassau, Bahamas
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
